<template>
  <sdCards :title="$t('pages.apps.packages.title')">
    <a-table :columns="columns" :data-source="data" size="small">
      <template #action="{ record }">
        <a-space>
          <a-button @click="editPackage(record.key)">
            <template #icon> <sdFeatherIcons type="edit" /> </template>
          </a-button>
          <a-button @click="deletePackage(record.id)">
            <template #icon> <sdFeatherIcons type="trash-2" /> </template>
          </a-button>
        </a-space>
      </template>
    </a-table>
    <br />
    <a-button type="primary" @click="newPackage"> {{ $t('common.add-new') }} </a-button>
  </sdCards>

  <a-modal
    v-model:visible="drawerVisible"
    width="650px"
    :title="$t('pages.apps.packages.title')"
    @ok="handleOk"
    :footer="null"
  >
    <a-form :model="insertData" layout="vertical" @submit="setPackage">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.packages.name-tr')" name="name">
            <a-input v-model:value="insertData.name" :placeholder="$t('pages.apps.packages.place-title')" required />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.packages.name-en')" name="name">
            <a-input v-model:value="insertData.name_en" :placeholder="$t('pages.apps.packages.place-title')" required />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.packages.code')" name="kod">
            <a-input v-model:value="insertData.code" :placeholder="$t('pages.apps.packages.place-code')" required />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.apps.packages.place-period')" name="day">
            <a-select v-model:value="insertData.day" required>
              <a-select-option value="7">{{ $t('pages.apps.packages.week') }}</a-select-option>
              <a-select-option value="30">{{ $t('pages.apps.packages.month') }}</a-select-option>
              <a-select-option value="365">{{ $t('pages.apps.packages.year') }}</a-select-option>
              <a-select-option value="3650">{{ $t('pages.apps.packages.lifetime') }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-item :label="$t('common.price')" name="price">
            <a-input v-model:value="insertData.price" :placeholder="$t('pages.apps.packages.place-price')" required />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('common.currency')" name="currency">
            <a-select v-model:value="insertData.currency" required>
              <a-select-option :value="currency.code" v-for="currency in currencies" :key="currency">
                {{ currency.code }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item :label="$t('pages.apps.packages.desc')" name="description">
            <a-textarea
              v-model:value="insertData.description"
              :rows="2"
              :placeholder="$t('pages.apps.packages.place-desc')"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-button style="margin-right: 8px" @click="hideDrawer">{{ $t('common.close') }}</a-button>
        <a-button htmlType="submit" type="primary">{{ $t('common.save') }}</a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: 'Package',
  data() {
    return {
      currencies: [],
      allData: [],
      insertData: {
        code: '',
        name: '',
        name_en: '',
        day: '7',
        price: '',
        currency: 'TRY',
        description: '',
        app_id: this.$route.params.id,
        id: 0,
      },
      drawerVisible: false,
      app_id: this.$route.params.id,
      data: [],
      columns: [
        {
          dataIndex: 'code',
          key: 'code',
          title: this.$t('pages.apps.packages.code'),
        },
        {
          dataIndex: 'name',
          key: 'name',
          title: this.$t('common.title'),
        },
        {
          dataIndex: 'day',
          key: 'day',
          title: this.$t('common.day'),
        },
        {
          dataIndex: 'period',
          key: 'period',
          title: 'Periyot',
        },
        {
          dataIndex: 'price',
          key: 'price',
          title: this.$t('common.price'),
        },
        {
          dataIndex: 'currency',
          key: 'currency',
          title: this.$t('common.currency'),
        },
        {
          title: this.$t('common.action'),
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  methods: {
    newPackage() {
      this.insertData.id = 0;
      this.getCurrencies();
      this.setDefaultInsertData();
      this.drawerVisible = true;
    },
    editPackage(id) {
      const data = this.allData[id];
      this.insertData.id = data.id;
      this.insertData.code = data.code;
      this.insertData.currency = data.currency;
      this.insertData.description = data.description;
      this.insertData.name = data.name;
      this.insertData.name_en = data.name_en;
      this.insertData.day = data.day.toString();
      this.insertData.price = data.price;
      this.getCurrencies();
      this.drawerVisible = true;
    },
    hideDrawer() {
      this.setDefaultInsertData();
      this.drawerVisible = false;
    },
    setPackage() {
      const endpoint = this.insertData.id == 0 ? this.$endpoints.app_package_set : this.$endpoints.app_package_update;

      this.$appAxios.post(endpoint, this.insertData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.getData();
          this.hideDrawer();
          this.setDefaultInsertData();
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    deletePackage(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }

      const formData = {
        app_id: this.app_id,
        id: id,
      };
      this.$appAxios.post(this.$endpoints.app_package_delete, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
          this.getData();
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
    getCurrencies() {
      this.$appAxios.post(this.$endpoints.app_currency_get, { id: this.app_id }).then((resp) => {
        if (resp.data.status) {
          this.currencies = resp.data.data;
        }
      });
    },
    getData() {
      this.data = [];
      const formData = {
        id: this.app_id,
        type: this.type,
      };
      this.$appAxios.post(this.$endpoints.app_package_get, formData).then((resp) => {
        if (resp.data.status) {
          this.allData = resp.data.data;
          var _this = this;

          this.allData.forEach(function (item, index) {
            _this.data.push({
              key: index,
              code: item.code,
              name: item.name,
              name_en: item.name_en,
              day: item.day,
              period: item.period,
              currency: item.currency,
              price: item.price,
              id: item.id,
            });
          });
        }
      });
    },
    setDefaultInsertData() {
      this.insertData = {
        code: '',
        name: '',
        day: '7',
        price: '',
        currency: 'TRY',
        description: '',
        app_id: this.$route.params.id,
        id: 0,
      };
    },
  },
  mounted() {
    this.getData();
  },
};
</script>